import { requestJson } from "./instateamAdminApi";

function buildTaskQuery(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value && value !== "all") {
      searchParams.set(key, value);
    }
  });

  return searchParams.toString() ? `?${searchParams.toString()}` : "";
}

export function getAdminTasks(token, params = {}) {
  return requestJson(`/instateam/tasks/admin${buildTaskQuery(params)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function createAdminTask(token, payload) {
  return requestJson("/instateam/tasks/admin", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function updateAdminTask(token, taskId, payload) {
  return requestJson(`/instateam/tasks/admin/${taskId}`, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function deleteAdminTask(token, taskId) {
  return requestJson(`/instateam/tasks/admin/${taskId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function getTaskPermissions(token) {
  return requestJson("/instateam/tasks/admin/permissions", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function updateTaskPermission(token, payload) {
  return requestJson("/instateam/tasks/admin/permissions", {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function removeTaskPermission(token, employeeId) {
  return updateTaskPermission(token, {
    employeeId,
    canAssignTasks: false,
    allowAllEmployees: false,
    assignableDepartments: [],
    assignableEmployees: [],
  });
}
